var _OPPOSITE_POSITION, _OPPOSITE_ANCHOR;

export var Position = {
  RIGHT: 'right',
  LEFT: 'left',
  TOP: 'top',
  BOTTOM: 'bottom'
};
export var OPPOSITE_POSITION = (_OPPOSITE_POSITION = {}, _OPPOSITE_POSITION[Position.RIGHT] = Position.LEFT, _OPPOSITE_POSITION[Position.LEFT] = Position.RIGHT, _OPPOSITE_POSITION[Position.TOP] = Position.BOTTOM, _OPPOSITE_POSITION[Position.BOTTOM] = Position.TOP, _OPPOSITE_POSITION);
export var Anchor = {
  START: 'start',
  CENTER: 'center',
  END: 'end'
};
export var OPPOSITE_ANCHOR = (_OPPOSITE_ANCHOR = {}, _OPPOSITE_ANCHOR[Anchor.START] = Anchor.END, _OPPOSITE_ANCHOR[Anchor.CENTER] = Anchor.CENTER, _OPPOSITE_ANCHOR[Anchor.END] = Anchor.START, _OPPOSITE_ANCHOR);